import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { api } from "../../helpers/utils";

export default function VerificationWaitListUsers() {
  const [users, setUsers] = useState([]);

  const fetchWaitListUsers = async () => {
    try {
      const res = await api.get("https://api1.pepchat.in/get-verification-waitlist");
      if (res.data.status === 100) {
        setUsers(res.data.users || []);
      }
    } catch (err) {
      console.error("Error fetching verification waitlist:", err);
    }
  };

  const handleVerify = (mobileNumber) => {
    window.location.href = `/admin/users/${mobileNumber}`;
  };

  useEffect(() => {
    fetchWaitListUsers();
  }, []);

  return (
    <Page>
      <Title>Users Waiting for Verification</Title>
      <SummaryBar>
        <SummaryItem>
          <span>Total waiting</span>
          <strong>{users.length}</strong>
        </SummaryItem>
        <SummaryItem tone="issue">
          <span>With issues</span>
          <strong>{users.filter((user) => Boolean(user.verificationIssue)).length}</strong>
        </SummaryItem>
      </SummaryBar>

      {users.length === 0 ? (
        <EmptyState>No users waiting for verification.</EmptyState>
      ) : (
        <List>
          {users.map((user, index) => (
            <UserCard key={user._id} hasIssue={Boolean(user.verificationIssue)}>
              <UserInfo>
                <Name>
                  {index + 1}. {user.userName || "Unnamed"}
                </Name>
                <Meta>{user.mobileNumber}</Meta>
                {user.verificationIssue ? (
                  <Issue>
                    <strong>Issue</strong>
                    <span>{user.verificationIssue}</span>
                  </Issue>
                ) : null}
              </UserInfo>
              <VerifyButton hasIssue={Boolean(user.verificationIssue)} onClick={() => handleVerify(user.mobileNumber)}>
                Review User
              </VerifyButton>
            </UserCard>
          ))}
        </List>
      )}
    </Page>
  );
}

const Page = styled.div`
  min-height: 100vh;
  background: #000000;
  color: #ffffff;
  padding: 60px 20px 120px;
  max-width: 1000px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: 34px;
  text-align: center;
  margin-bottom: 30px;

  @media (max-width: 560px) {
    font-size: 26px;
  }
`;

const EmptyState = styled.p`
  text-align: center;
  color: #bdbdbd;
  margin-top: 60px;
`;

const SummaryBar = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 28px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const SummaryItem = styled.div`
  border: 1px solid ${({ tone }) => (tone === "issue" ? "#a16207" : "#303030")};
  background: ${({ tone }) => (tone === "issue" ? "rgba(161, 98, 7, 0.12)" : "#050505")};
  padding: 16px;

  span,
  strong {
    display: block;
  }

  span {
    color: #bdbdbd;
    font-size: 12px;
    text-transform: uppercase;
  }

  strong {
    margin-top: 8px;
    color: #ffffff;
    font-size: 28px;
  }
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const UserCard = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
  background: #050505;
  padding: 20px 24px;
  border: 1px solid ${({ hasIssue }) => (hasIssue ? "#a16207" : "#303030")};
  border-left: ${({ hasIssue }) => (hasIssue ? "5px solid #a16207" : "1px solid #303030")};

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Name = styled.span`
  font-size: 17px;
  font-weight: 800;
`;

const Meta = styled.span`
  font-size: 14px;
  color: #bdbdbd;
`;

const Issue = styled.span`
  display: grid;
  gap: 4px;
  width: fit-content;
  max-width: 100%;
  border: 1px solid #a16207;
  background: rgba(161, 98, 7, 0.14);
  padding: 8px 10px;

  strong {
    color: #fde68a;
    font-size: 12px;
    text-transform: uppercase;
  }

  span {
    color: #ffffff;
    font-size: 13px;
    line-height: 1.45;
  }
`;

const VerifyButton = styled.button`
  padding: 12px 24px;
  border: 1px solid ${({ hasIssue }) => (hasIssue ? "#a16207" : "#ffffff")};
  background: ${({ hasIssue }) => (hasIssue ? "rgba(161, 98, 7, 0.12)" : "#ffffff")};
  color: ${({ hasIssue }) => (hasIssue ? "#ffffff" : "#000000")};
  font-weight: 800;
  cursor: pointer;

  &:hover {
    background: ${({ hasIssue }) => (hasIssue ? "#a16207" : "#000000")};
    color: #ffffff;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;
